module.exports = __webpack_public_path__ + "img/m4x8lluomudaozhu.prt.631ba15e.jpg";